import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import MultilineEllipsisText from 'rebook/apps/base/components/MultilineEllipsisText';
import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


const UserBookshelf = ({ bookshelf, extraClassName, userId }) => {
  if (!bookshelf) {
    return null;
  }

  return (
    <div className={classNames(styles.bookshelf, 'swiper-slide', extraClassName, 'jest-user-bookshelf')}>
      <Link to={`/profile/${userId}/bookshelves/${bookshelf.id}/`}>
        <div className={styles.bookshelfContent}>
          <div className={styles.title}>
            <MultilineEllipsisText maxLinesCount={2}>{bookshelf.name}</MultilineEllipsisText>
          </div>
          <div className={styles.image}>
            {bookshelf.image && (
              <CroppedImage
                height="48"
                width="48"
                src={bookshelf.image}
                alt={bookshelf.name} />
            )}
          </div>
        </div>
        <div className={styles.count}>
          {bookshelf.book_count > 0 && (
            <span>
              {bookshelf.book_count}&nbsp;
              {pluralize(bookshelf.book_count, 'книга', 'книги', 'книг')}
            </span>
          )}
          {(bookshelf.book_count > 0) && (
            <span className={styles.circle} />
          )}
          {bookshelf.is_public
            ? <span>Видна всем</span>
            : <span>Скрыта</span>
          }
        </div>
      </Link>
    </div>
  );
};

UserBookshelf.propTypes = {
  bookshelf: PropTypes.shape({
    name: PropTypes.string.isRequired,
    image: PropTypes.string,
    book_count: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    is_public: PropTypes.boolean,
  }),
};


export default UserBookshelf;
